module.exports = __webpack_public_path__ + "img/mess-bg.c4a3c480.svg";